/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentDto } from '../../models/content-dto';
import { CreateContentDto } from '../../models/create-content-dto';

export interface AdminContentControllerCreate$Params {
      body: CreateContentDto
}

export function adminContentControllerCreate(http: HttpClient, rootUrl: string, params: AdminContentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDto>> {
  const rb = new RequestBuilder(rootUrl, adminContentControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentDto>;
    })
  );
}

adminContentControllerCreate.PATH = '/api/content/admin';
